import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c(VAlert,{staticClass:"maintenance-banner",attrs:{"color":"amber darken-1","dark":"","dense":"","icon":"mdi-alert-circle-outline","dismissible":""},on:{"input":_vm.onDismiss}},[_c('div',{staticClass:"d-flex align-center justify-space-between"},[_c('div',{staticClass:"banner-content"},[_c(VIcon,{staticClass:"mr-2",attrs:{"small":""}},[_vm._v("mdi-wrench")]),_c('span',{staticClass:"banner-message"},[_vm._v(_vm._s(_vm.message))])],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }